import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => ({
  root: {
    '&.special-offers': {
      backgroundColor: "#F7F7F7",
      paddingTop: 80,
      paddingBottom: 80,
      marginBottom: 80,
      [theme.breakpoints.down('md')]: {
        paddingTop: 64,
        marginBottom: 56,
        paddingBottom: 64,
      },

      '& .richText': {
        '& h2': {
          fontSize: pxToRem(48),
          lineHeight: pxToRem(56),
          fontFamily: theme.custom.fontFamily.primaryBold,
          fontWeight: 400,

          [theme.breakpoints.down('md')]: {
            fontSize: pxToRem(32),
            lineHeight: pxToRem(40),
          },
        },

        '& h1:first-of-type': {
          marginTop: 0,
        },
        '& h2:first-of-type': {
          marginTop: 0,
        },
        '& h3:first-of-type': {
          marginTop: 0,
        },
        '& h4:first-of-type': {
          marginTop: 0,
        },
        '& h5:first-of-type': {
          marginTop: 0,
        },
        '& h6:first-of-type': {
          marginTop: 0,
        },

        "& ul": {
          ...theme.mixins.paddingLeft(22),
          [theme.breakpoints.down('md')]: {
            ...theme.mixins.paddingLeft(17),
          },
          '& li': {
            fontSize: '22px',
            lineHeight: '32px',
            fontFamily: theme.custom.fontFamily.primaryRegular,
            marginBottom: 8,
            [theme.breakpoints.down('md')]: {
              fontSize: '16px',
              lineHeight: '24px',
            },
            '&::marker': {
              color: '#FF8707',
            },
          },
        },
        '& a': {
          fontSize: '22px',
          lineHeight: '32px',
          color: '#009086',
          textDecoration: 'underline',
          fontFamily: theme.custom.fontFamily.primaryRegular,
          [theme.breakpoints.down('md')]: {
            fontSize: '16px',
            lineHeight: '24px',
          },
        },
        '& p': {
          fontSize: '22px',
          lineHeight: '32px',
          fontFamily: theme.custom.fontFamily.primaryRegular,
          [theme.breakpoints.down('md')]: {
            fontSize: '16px',
            lineHeight: '24px',
          },
        },
        '& span': {
          fontSize: '22px',
          lineHeight: '32px',
          fontFamily: theme.custom.fontFamily.primaryRegular,
          [theme.breakpoints.down('md')]: {
            fontSize: '16px',
            lineHeight: '24px',
          },
        },
        '& p': {
          fontFamily: theme.custom.fontFamily.primaryRegular,
        },
        '& span': {
          fontFamily: theme.custom.fontFamily.primaryRegular,
        },

        '& strong': {
          fontFamily: theme.custom.fontFamily.primaryBold,
          fontWeight: 400,
        },
      },
    },
    ...theme.shape.componentSpacing,
    '& .player-wrapper': {
      '& .eko-player': {
        [theme.breakpoints.down('md')]: {
          ...theme.mixins.marginLR(pxToRem(-24), pxToRem(-24)),
        },
      },
    },
  },
}));
export default useStyles;
